export enum E_ShareType {
    TECH_MIND = 'TECH_MIND',
    MATERIAL_MIND = 'MATERIAL_MIND',
    MATERIAL_MIND_V2 = 'MATERIAL_MIND_V2',
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_RESEARCH = 'TECH_RESEARCH',
    NEWS_LETTER = 'NEWS_LETTER',
    AI_AGENT = 'AI_AGENT',
    PROJECT = 'WORK_PROJECT',
    AI_COMPANY_TECH_MONITOR = 'AI_COMPANY_TECH_MONITOR',
    TRIZ_MIND = 'TRIZ_MIND',
    IRA_CONVERSATION = 'IRA_CONVERSATION'
}

export enum ShareRole {
    OWNER = 'OWNER',
    COLLABORATOR = 'COLLABORATOR'
}

export interface ShareAuthRequiredData {
    id: string;
    type: E_ShareType;
    triggerButtonSource?: string;
}

export const SHARE_TYPE_MAP = {
    '': E_ShareType.SEEK_SEARCH,
    whiteboard: [E_ShareType.TECH_MIND, E_ShareType.MATERIAL_MIND, E_ShareType.MATERIAL_MIND_V2],
    project: E_ShareType.TECH_RESEARCH,
    newsletter: E_ShareType.NEWS_LETTER,
    ai: E_ShareType.AI_AGENT,
    graph: E_ShareType.PROJECT,
    monitor: E_ShareType.AI_COMPANY_TECH_MONITOR,
    triz: E_ShareType.TRIZ_MIND,
    '': E_ShareType.IRA_CONVERSATION,
} as const

// 添加一个辅助函数来判断类型
export function isWhiteboardShareType(type: E_ShareType): boolean {
    return type === E_ShareType.TECH_MIND || type === E_ShareType.MATERIAL_MIND
}

// 添加一个函数来获取分享路径
export function getSharePath(type: E_ShareType): string {
    if (isWhiteboardShareType(type)) {
        return 'whiteboard'
    }

    for (const [path, shareType] of Object.entries(SHARE_TYPE_MAP)) {
        if (Array.isArray(shareType)) {
            if (shareType.includes(type)) {
                return path
            }
        } else if (shareType === type) {
            return path
        }
    }

    throw new Error(`Unknown share type: ${type}`)
}
